<div class="d-flex justify-content-end">
    <button
        mat-icon-button
        mat-dialog-close>
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>
<div class="d-flex justify-content-center text-center flex-column">
    <div class="">
        <div class="w-100">
            <img
                src="./assets/images/truck.svg"
                height="24" />
        </div>
    </div>
    <div class="mt-3">
        <h2>
            {{
                'OUTGOING-GOODS.CHECKOUT.SIGNATURE-DIALOG.HEADLINE' | translate
            }}
        </h2>
    </div>

    <a [href]="externalSignatureUrl">
        @if (externalTokens) {
            <qr-code
                [value]="externalSignatureUrl"
                size="200"
                errorCorrectionLevel="M"
                centerImageSrc="./assets/images/truck.png"
                centerImageSize="40"
                [margin]="4">
            </qr-code>
        }
    </a>
    <div class="space-line"></div>
    <div
        class="sub-headline"
        [innerHTML]="
            'OUTGOING-GOODS.CHECKOUT.SIGNATURE-DIALOG.SUBHEADLINE' | translate
        "></div>
    @if (!driverSignatureSucceeded) {
        <div class="mt-4">
            <div class="signature-desc">
                {{
                    'OUTGOING-GOODS.CHECKOUT.SIGNATURE-DIALOG.DESCRIPTION'
                        | translate
                }}
            </div>
            <div class="signature-pad">
                <form [formGroup]="signatureForm">
                    <app-signature-field
                        formControlName="driverSignature"
                        (signatureCleared)="changeSignatureStatus(false)"
                        (signatureDrawCompleted)="changeSignatureStatus(true)">
                        <button
                            mat-icon-button
                            class="tw-absolute tw-bottom-2 tw-right-2"
                            matTooltip="Unterschrift von externem Gerät laden"
                            (click)="pullSignature()">
                            <mat-icon fontSet="material-symbols-outlined"
                                >mobile_friendly</mat-icon
                            >
                        </button></app-signature-field
                    >
                </form>
            </div>
        </div>
    }
    @if (driverSignatureSucceeded) {
        <div class="mt-4">
            <img
                [src]="driverSignatureImage"
                class="img-fluid"
                alt="Signature" />
        </div>
    }
    <div class="mt-4">
        <button
            mat-raised-button
            color="accent"
            (click)="saveFormData()"
            [disabled]="!readyToSave">
            {{ 'OUTGOING-GOODS.CHECKOUT.SIGNATURE-DIALOG.BUTTON' | translate }}
        </button>
    </div>
</div>
